import React, { memo, useCallback, useEffect } from 'react';
import { View, Image, ActivityIndicator, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';
import { useCounter } from '@redlink/core';

export const AddItem = memo(({onReady}) => {
  const { styles } = useStyle();
  const { timer, startCounter } = useCounter({
    start: 10,
    end: 0,
    onCompleted: onReady,
  });

  useEffect(() => startCounter(), []);

  const onPress = useCallback(() => {
    window.location.href = 'https://search4.ir';
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <Text style={styles.titleText}>در حال انتقال ...</Text>
        <Space size={8} />
        <ActivityIndicator color="red" size="small" />
      </View>
      <Text style={styles.timerText}>{timer}</Text>
      <Space size={70} />
      <TouchableOpacity activeOpacity={0.7} onPress={onPress}>
        <Image
          source={{ uri: 'https://resources.srh4.ir/search4-banner-2.jpg' }}
          style={styles.image}
        />
      </TouchableOpacity>
      <Space size={4} />
      <Button
        textStyle={styles.actionButton}
        variant="link"
        title="آموزش زبان با فیلم و انیمیشن"
        onPress={onPress}
      />
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: colors.gray23,
    textAlign: 'left',
  },
  timerText: {
    fontSize: 25,
    fontWeight: 'bold',
  },
  image: {
    width: size.previewCompactMaxWidth,
    height: size.previewCompactMaxWidth / 1.5,
    borderRadius: 15,
  },
  headerContainer: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  actionButton: {
    fontSize: 18,
  },
}));
